export default __webpack_public_path__ + "static/media/payroll-1.814ff64c.svg";